import React, {useContext} from 'react';
import { 
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    Typography,
    makeStyles
} from '@ellucian/react-design-system/core';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import useApplicationForm from './useApplicationForm';
import ExperienceContext from '../../ExperienceContext';

const useStyles = makeStyles(() => ({
    tableCell: {
        wordBreak: 'break-word',
        'white-space': 'pre-wrap'
    },
}));

const ApsSaveWarningTable = (props) => {
    const intl = useIntl();
    const classes = useStyles();
    const { changes, stagerMode } = props;
    const {
        template = { pages: [] },
    } = useApplicationForm();
    const { locale } = useContext(ExperienceContext);
    return (
        <div>
            {!!changes?.length &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <FormattedMessage id="applicationProcessingAdminApplicationFieldName"/>
                            </TableCell>
                            <TableCell>
                                <FormattedMessage id="applicationProcessingAdminApplicationOldValue"/>
                            </TableCell>
                            <TableCell>
                                <FormattedMessage id="applicationProcessingAdminApplicationNewValue"/>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!stagerMode && changes.map((change) => (
                            <TableRow key={change.key} className={classes.changesDisplay}>
                                <TableCell className={classes.tableCell}>
                                    <Typography>{ template.templateMessages.languages[locale].messages[change.label] }</Typography>                                                                
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    <Typography>{ change.oldValue ? change.oldValue  : intl.formatMessage({id: 'applicationProcessingAdminApplicationBlank'}) }</Typography>
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    <Typography>{ change.value ? change.value : intl.formatMessage({id: 'applicationProcessingAdminApplicationBlank'}) } </Typography>
                                </TableCell>
                            </TableRow>                                
                        ))}
                        {stagerMode && changes.map((change) => (
                            <TableRow key={change.key} className={classes.changesDisplay}>
                                <TableCell className={classes.tableCell}>
                                    <Typography>{ change.propertyName }</Typography>                                                                
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    {!!change.oldValue?.length && change.oldValue.map((oldVal) => (
                                        <div key={oldVal}>
                                            {typeof oldVal === 'object' && Object.keys(oldVal).map((k, i) => (
                                                <Typography key={k}>{intl.formatMessage({id: 'applicationProcessingSaveWarningLabel'}, {key: k, value: Object.values(oldVal)[i]})}</Typography> 
                                            ))}                               
                                            {typeof oldVal === 'string' && oldVal.length !== 0 && <Typography>{oldVal}</Typography>}
                                            {typeof oldVal === 'string' && oldVal.length === 0 && <Typography>{intl.formatMessage({id: 'applicationProcessingAdminApplicationBlank'})}</Typography>}                  
                                        </div>
                                    ))}
                                    {!change.oldValue?.length &&
                                        <Typography>{intl.formatMessage({id: 'applicationProcessingAdminApplicationBlank'})}</Typography>
                                    }
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    {!!change.newValue?.length && change.newValue.map((newVal) => (
                                        <div key={newVal}>
                                            {typeof newVal === 'object' && Object.keys(newVal).map((k, i) => (
                                                <Typography key={k}>{intl.formatMessage({id: 'applicationProcessingSaveWarningLabel'}, {key: k, value: Object.values(newVal)[i]})}</Typography> 
                                            ))}                                  
                                            {typeof newVal === 'string' && newVal.length !== 0 && <Typography>{newVal}</Typography>}
                                            {typeof newVal === 'string' && newVal.length === 0 && <Typography>{intl.formatMessage({id: 'applicationProcessingAdminApplicationBlank'})}</Typography>}
                                        </div>
                                    ))}
                                    {!change.newValue?.length &&
                                        <Typography>{intl.formatMessage({id: 'applicationProcessingAdminApplicationBlank'})}</Typography>
                                    }
                                </TableCell>
                            </TableRow>                                
                        ))}
                    </TableBody>
                </Table>
            }
        </div>
    );
};

ApsSaveWarningTable.propTypes = {
    changes: PropTypes.array.isRequired,
    stagerMode: PropTypes.bool
};

export default ApsSaveWarningTable;